import type { TrackingSource } from "./types";

/**
 * Booking sources that mean "a partner venue sent us this guest", mirroring the
 * `Booking::SOURCE_*` constants in the legacy `dmn` monolith.
 */
const PARTNER_SOURCES = new Set(["partner", "partner_facebook", "reservewithgoogle"]);

export interface TrackingSourceInput {
  readonly source?: string | null;
  readonly affiliateId?: string | null;
}

/**
 * Decides who commercially owns the journey.
 *
 * A booking belongs to a partner only when it carries an affiliate or arrived
 * through one of the {@link PARTNER_SOURCES}. Everything else is
 * DesignMyNight's, including an unknown, missing or blank source: an
 * unattributed journey is reported to our own destinations rather than
 * credited to a partner that may not exist.
 */
export function resolveTrackingSource({ source, affiliateId }: TrackingSourceInput): TrackingSource {
  if (affiliateId?.trim()) return "partner";

  const normalised = source?.trim().toLowerCase();
  if (!normalised) return "dmn";

  return PARTNER_SOURCES.has(normalised) ? "partner" : "dmn";
}
